import {apiRequest} from "../services/utils/HttpUtils";
import {GET_USER_INFO} from "./mutations_landing_page_consent";
import { useQuery } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";

export function getUserInfo() {
  const client = useQueryClient();
  const {instance, accounts} = useMsal();
  const isAuthenticated = useIsAuthenticated();
  return useQuery(["getUserInfo"], {
      queryFn: () => {
        return apiRequest(
          {
            query: GET_USER_INFO,
            instance: instance,
            accounts: accounts
          })
      },
      enabled: isAuthenticated,
      onSuccess: (data) => {
        client.invalidateQueries(["Lists"]);
        client.invalidateQueries(["stateResult"]);
      }
    });
}
